<template>
    <div class="row">
      <label class="col-4 col-form-label">
        Цвет
        <span
          class="badge"
          :style="{'background-color': color.hex}">
          {{color.hex}}
        </span>
      </label>
      <div class="col-8">
        <color-picker
          v-model="color"
          @input="$emit('input', color.hex)"/>
      </div>
    </div>
</template>

<script>
import { Slider } from 'vue-color'

export default {
  name: 'TcColorPicker',
  props: {
    value: {
      type: String,
      default: '#BF4040'
    }
  },
  components: {
    'color-picker': Slider
  },
  data () {
    return {
      color: {
        hex: this.value
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// TcColorPicker.vue?4d8da34c